export enum ChatPlatform {
    Cliq = "cliq",
    Teams = "teams",
    Slack = "slack",
    GoogleChat = "googleChat"
}

export interface ChatBot {
    id: string;
    name: string;
    platform: ChatPlatform;
    platformBotId: string;
    knowledgeBaseUid: string;
    companyId: number;
    isActive: boolean;
    createdByUid: string | null;
    createdAt: string;
    updatedAt: string;
    cliqBotId: string;
    webhookUrl: string;
    hasCredentials: boolean;
}

export interface CreateChatBotRequest {
    name: string;
    platform: ChatPlatform;
    platformBotId: string;
    knowledgeBaseUid: string;
    credentials?: Record<string, string>;
}

export interface UpdateChatBotRequest {
    name?: string;
    platformBotId?: string;
    isActive?: boolean;
    credentials?: Record<string, string>;
}
